module.exports = __webpack_public_path__ + "img/suarez.a53cc5e5.png";